import { render, staticRenderFns } from "./AvailableMetaFields.vue?vue&type=template&id=2dc60fa8"
import script from "./AvailableMetaFields.vue?vue&type=script&lang=js"
export * from "./AvailableMetaFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports